/* eslint-disable react-hooks/exhaustive-deps */
import { Avatar, Icon, IconButton, Tooltip } from "@mui/material";
import { FC, ReactNode, useEffect, useState } from "react";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { InputSelectSimple } from "src/framework/components/forms/inputs/InputSelectSimple";
import api, { apiNoLoading, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { useObservable } from "src/framework/store/storeUtil";
import { cidades$, distribuidores$, estados$, verificarSegmentoConta } from "src/store/global.store";
import theme from "src/theme/light";
import { Cidade, Estado } from "src/types";
import { SITUACAO, Verticais } from "../vendas/types";
import { CIDADES_FIELD, DATA_ETAPA_FINAL_FIELD, DATA_ETAPA_INICIO_FIELD, DEFAULT_PRIORIDADE_PROJETOS_VERTICAIS, DISTRIBUIDOR_FIELD, ESTADOS_FIELD, ETAPA_VENDA_FIELD, LISTA_ETAPA_VENDA_PROJETOS_VERTICAIS, LISTA_PRIORIDADE_PROJETOS_VERTICAIS, LISTA_SITUACAO_PROJETOS_VERTICAIS, PRIORIDADE_FIELD, RANGE_PONTENCIA_FINAL_FIELD, RANGE_PONTENCIA_INICIO_FIELD, REVENDA_FIELD, SITUACAO_FIELD } from "./constants";
import { DEFAULT_PROJETO, FILTER } from "./constants";
import { EtapaProjetoType, ModalProposta, PrioridadeType, SituacaoType } from "./types";
import { DataGridStore } from "src/framework/store/DataGridStore";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { ExtraInfoUsuario } from "src/providers/cadastros/ContaProvider/types";
import { paths, VerticaisManager } from "../vendas/VerticaisManager";
import { ProjetoPrioridadeDom, ProjetosPrioridadeModel } from "./prioridade";
import { CSSProperties } from "react";
import { orange, red } from "@mui/material/colors";
import { useHistory } from "react-router-dom";
import { formState$ } from "src/store/vendas/projetos/store";
import { ModalPropostas } from "./ModalPropostas";
import adminStore from "src/store/AdminStore";
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { notifierStore } from "src/framework/store/NotifierStore";
import { Filter } from "src/framework/commons/FilterUtil";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList";
import { InputComboBox } from "src/framework/components/forms/inputs/InputComboBox";
import { InputDateTime } from "src/framework/components/forms/inputs/InputDateTime";
import { InputDecimal } from "src/framework/components/forms/inputs/InputDecimal";
import { ActionMenu, ActionMenuProperties } from "src/framework/components/base/ActionMenu";
import { ColumnDefinition } from "src/framework/store/DataTableStore";
import { DataGrid, DataGridProperties } from "src/framework/components/base/DataGrid";

const manager: VerticaisManager = new VerticaisManager(paths, api, apiNoLoading);
export interface ListagemProperties {
    doSearch: boolean;
    distribuidorRevendaUsuario: any;
    onEdit: (row: any) => void;
    cancelSearch: () => void
}

export const parsePrioridadeProjeto = (status: PrioridadeType): string => {
    switch (status) {
        case "media":
            return "Média";
        case "alta":
            return "Alta";
        default:
            return "Baixa";
    }
}

export const parsePrioridadeProjetoColor = (status: PrioridadeType): any => {
    switch (status) {
        case "media":
            return orange[200];
        case "alta":
            return theme.palette.primary.light;
        default:
            return null;
    }
}

export const parseStatusProjeto = (status: SituacaoType): string => {
    switch (status) {
        case "cancelado":
            return "Cancelado";
        case "expirado":
            return "Expirado";
        case "finalizado":
            return "Finalizado";
        case "pendente":
            return "Pendente";
        case "pausado":
            return "Pausado";
        default:
            return "Pendente"
    }
}

const projetosProvider = new ProjetosProvider()

export const parseEtapaVenda = (etapa: EtapaProjetoType) => {
    switch (etapa) {
        case "aguardando_faturamento":
            return "Aguardando faturamento";

        case "aguardando_pagamento":
            return "Aguardando pagamento";

        case "em_transito":
            return "Em transito";

        case "entregue":
            return "Entregue";

        case "faturado":
            return "Faturado";

        case "negociacao":
            return "Em negociação";

        case "pre_orcamento":
            return "Pré-orçamento";

        case "sla_engenharia":
            return "SLA engenharia"
    }

}

const Listagem: FC<ListagemProperties> = ({
    doSearch = false,
    onEdit,
    cancelSearch,
}) => {
    const history = useHistory();

    const [dataPrioridade, setDataPrioridade] = useState<ProjetoPrioridadeDom | null>(null);
    const [openPrioridade, setOpenPrioridade] = useState<boolean>(false);

    const [dataGridStore] = useState(new DataGridStore(api));

    const [filterState, setFilterState] = useState<Filter[]>(FILTER || []);
    const [distribuidorState, setDistribuidorState] = useState<any>(null);

    const cidadeListState = useObservable(cidades$);
    const distribuidorListState = useObservable(distribuidores$);
    const estadoListState = useObservable(estados$);

    const [distribuidorRevendaUsuario, setDistribuidorRevendaUsuario] = useState<ExtraInfoUsuario | null>(null);

    const [dataModalProposta] = useState<ModalProposta | null>(null);
    const [openModalProposta, setOpenModalProposta] = useState<boolean>(false);

    useEffect(() => {
        if (distribuidorRevendaUsuario?.isDistribuidor) {
            if (distribuidorRevendaUsuario?.distribuidor_id !== null) {
                const idx = distribuidorListState?.data?.findIndex((f: any) => f.id === distribuidorRevendaUsuario?.distribuidor_id) || -1;
                if (idx > -1) {
                    setDistribuidorState(distribuidorListState?.data[idx]);
                }
            }
        }
    }, [distribuidorRevendaUsuario]);

    const init = async (): Promise<void> => {
        const distribuidorRevenda = LocalStorage.get("solar.userExtraInfo", true)
        setDistribuidorRevendaUsuario(distribuidorRevenda)
    }

    const finalizar = async (codigoVenda: string, triangular: boolean): Promise<void> => {
        const response: IDataResponse = await manager.finalizar(codigoVenda, triangular)
        if (response.statusCode === STATUS_CODE.OK) {
            dataGridStore.setFilter([...filterState]);
            dataGridStore.list();
            confirmationDialog.close();
        }
    }

    const doFinalizar = (row: any, triangular: boolean) => {
        confirmationDialog.setup({
            title: "Aviso!",
            content: `Deseja enviar para pagamento o projeto ${row.codigo_venda}?`,
            onClose: () => {
                confirmationDialog.close();
            },
            onConfirmation: () => {
                confirmationDialog.close();
                finalizar(row.codigo_venda, triangular);
            }
        })
        confirmationDialog.open()
    }

    const doPrioridade = async (data: ProjetoPrioridadeDom) => {
        const response: IDataResponse = await manager.prioridade(data.id || 0, data.prioridade || DEFAULT_PRIORIDADE_PROJETOS_VERTICAIS);
        if (response.statusCode === STATUS_CODE.OK) {
            dataGridStore.setFilter([...filterState]);
            dataGridStore.list();
            confirmationDialog.close();
        }
    }

    const renderDistribuidor = (): ReactNode => {
        return (
            <InputComboBoxList
                key={`projetos-distribuidor`}
                options={distribuidorListState?.data || []}
                label={"Distribuidor"}
                textField="nome"
                valueField="id"
                value={filterState[DISTRIBUIDOR_FIELD.index].value}
                renderOptions={(option: any) => {
                    return `${option.nome} (${option.cnpj_cpf})`
                }}
                renderOptionsLabel={(option: any) => {
                    return `${option.nome} (${option.cnpj_cpf})`
                }}
                onChange={(value: any) => {
                    setDistribuidorState(value ? { ...value } : null);
                    const filter = [...filterState];
                    const idx = filter.findIndex((f) => f.field === DISTRIBUIDOR_FIELD.name);
                    if (idx > -1) {
                        filter[idx].value = value ? value : null;
                        setFilterState([...filter]);
                    }

                }}
            />
        );
    }

    const renderRevenda = (): ReactNode => {
        return (
            <InputComboBox
                key={`projetos-revenda`}
                path={distribuidorState ? `/cadastros/contas/revendas/${distribuidorState.id}` : ""}
                label={"Revenda"}
                provider={apiNoLoading}
                textField="nome"
                valueField="id"
                value={filterState[REVENDA_FIELD.index].value}
                renderOptions={(option: any) => {
                    return `${option.nome} (${option.cnpj_cpf})`
                }}
                renderOptionsLabel={(option: any) => {
                    return `${option.nome} (${option.cnpj_cpf})`
                }}
                onChange={(value: any) => {
                    const filter = [...filterState];
                    const idx = filter.findIndex((f) => f.field === REVENDA_FIELD.name);

                    if (idx > -1) {
                        filter[idx].value = value ? value : null;
                        setFilterState([...filter]);
                    }

                }}
            />
        )
    }

    useEffect(() => {
        if (doSearch) {
            dataGridStore.list().finally(() => cancelSearch());
        }
    }, [doSearch])

    const renderActionMenu = (row: any) => {
        let menu: ActionMenuProperties = {
            selected: null,
            menuItens: [],
        };


        // --------------------------------------------------------
        // TODO: Remover quando a nova listagem de projetos subir..
        menu.menuItens.push({
            label: 'Editar',
            onClick: () => {
                adminStore.buscarProjeto(row?.id, true).then((resp) => {
                    if (resp?.length) {
                        formState$.next(DEFAULT_PROJETO);
                        history.push(`/projetos/${row.id}/edicao`)
                    }
                });
            },
            icon: "edit",
        })
        // --------------------------------------------------------

        const projeto: Verticais = (row as Verticais)
        const situacao: string = (row as Verticais).situacao.toString();
        const etapa: string = `${(row as Verticais)?.etapa_venda}`;
        if (situacao === "pendente" && ["pre_orcamento"].includes(etapa)) {
            menu.menuItens.push({
                label: "Enviar p/ pagamento",
                key: `finalizar-${row.id}`,
                icon: "done",
                onClick: async () => {
                    const validarSegmentoConta = await verificarSegmentoConta({ 
                        segmento: projeto?.segmento || 'on', 
                        revendaId: projeto?.revenda_id || projeto?.revenda?.id || undefined, 
                        distribuidorId: projeto?.distribuidor_id || projeto?.distribuidor?.id || undefined
                    });
                    if (!validarSegmentoConta) return;

                    confirmationDialog.setup({
                        title: "Aviso!",
                        content: `Enviar para pagamento com triangulação de nota?`,
                        onClose: () => {
                            confirmationDialog.close();
                            doFinalizar(row, false)
                        },
                        onConfirmation: () => {
                            confirmationDialog.close();
                            doFinalizar(row, true)
                        }
                    })

                    adminStore.buscarProjeto(row?.id, true).then((resp) => {
                        if (resp?.length) confirmationDialog.open()
                    });
                },
            });
        }

        if (["pendente", "expirado", "pausado"].includes(situacao) && ["sla_engenharia", "pre_orcamento"].includes(etapa)) {
            menu.menuItens.push({
                label: "Prioridade",
                key: `prioridade-${row.id}`,
                icon: "done",
                onClick: () => {
                    adminStore.buscarProjeto(row?.id, true).then((resp) => {
                        if (resp?.length) {
                            setDataPrioridade({
                                id: projeto?.id,
                                prioridade: projeto?.prioridade,
                            });
                            setOpenPrioridade(true);
                        }
                    });
                },
            })
        }
    
        if (["pendente", "expirado"].includes(situacao)
            && !['aguardando_pagamento', 'negociacao', 'aguardando_faturamento',
                'faturado', 'em_transito', 'entregue'].includes(etapa)
        ) {
            menu.menuItens.push({
                label: "Cancelar",
                key: `cancelar-${projeto.id}`,
                icon: "cancel",
                onClick: () => {
                    confirmationDialog.setup({
                        title: "Aviso!",
                        content: `Deseja cancelar o projeto ${projeto.codigo_venda}?`,
                        onClose: () => {
                            confirmationDialog.close();
                        },
                        onConfirmation: () => {
                            const projetosCancelar = [String(projeto?.id)]
                            projetosProvider.cancelar(projetosCancelar).then((response) => {
                                if (response.statusCode === STATUS_CODE.OK) {
                                    notifierStore.setNotifier({
                                        title: "Aviso!",
                                        content: "Projeto cancelado com sucesso",
                                        timeOut: 3000,
                                        onClose: () => {
                                            notifierStore.setOpen(false);
                                        }
                                    })
                                    notifierStore.setOpen(true);
                                    dataGridStore.list();
                                } else {
                                    notifierStore.setNotifier({
                                        title: "Aviso!",
                                        content: response.message,
                                        timeOut: 3000,
                                        onClose: () => {
                                            notifierStore.setOpen(false);
                                        }
                                    })
                                    notifierStore.setOpen(true);
                                }
                            })
                        }
                    })

                    adminStore.buscarProjeto(row?.id, true).then((resp) => {
                        if (resp?.length) confirmationDialog.open()
                    });
                },
            });
        }

        return (
            <>
                <ActionMenu {...menu} />
            </>
        );
    };
    
    const defaultColumn: ColumnDefinition[] = [
        {
            field: "",
            headerName: "",
            sortable: false,
            width: 5,
            render: (row: any) => {
                const situacao: string = (row as Verticais).situacao.toString();
                const etapaVenda: string = `${(row as Verticais)?.etapa_venda}`;
                const revisao: boolean = (["pre_orcamento"].includes(etapaVenda) && ["pendente", "expirado"].includes(situacao))
                    || (["sla_engenharia"].includes(etapaVenda) && ["pausado"].includes(situacao));

                return <>
                    <Tooltip title={!revisao ? '' : 'Enviar revisão de proposta'}>
                        <IconButton
                            disabled={!revisao}
                            size="small"
                            onClick={async () => {
                                await getRevisao(row)
                            }}
                        >
                            <Icon>list</Icon>
                        </IconButton>
                    </Tooltip>
                </>
            },
        },
        {
            field: "action",
            headerName: "",
            sortable: false,
            width: 10,
            render: renderActionMenu,
        },
        {
            field: "prioridade",
            headerName: "Prior.",
            description: "Prioridade do Projeto",
            sortable: true,
            type: TypeRecords.TEXT,
            width: 40,
            align: "center",
            render: (row: any, style?: CSSProperties): React.ReactNode => {
                const prioridade: PrioridadeType = row?.prioridade || "baixa";
                const prioridadeLabel = parsePrioridadeProjeto(prioridade as any);
                const color = parsePrioridadeProjetoColor(prioridade as any);
                return (
                    <Tooltip title={`Prioridade: ${prioridadeLabel}`} placement="bottom">
                        <Avatar aria-label="recipe" style={{ backgroundColor: color }}>
                            {prioridadeLabel.charAt(0)}
                        </Avatar>
                    </Tooltip>
                )
            }
        },
        {
            field: "codigo_venda",
            headerName: "Código projeto",
            sortable: true,
            type: TypeRecords.TEXT,
            width: 40,
        },
        {
            field: "titulo",
            headerName: "Título",
            sortable: true,
            type: TypeRecords.TEXT,
            width: 200,
            render: (row: any) => {
                const projeto: Verticais = (row as Verticais);
                return <>{projeto?.titulo ? String(projeto?.titulo) : ""}</>
            }
        },
        {
            field: "etapa_Venda",
            headerName: "Etapa venda",
            sortable: true,
            type: TypeRecords.TEXT,
            width: 80,
            render: (row: any) => {
                const projeto: Verticais = (row as Verticais);
                return (
                    <>
                        <Tooltip title={`Data ${Formater.toString(projeto.data_etapa_venda, TypeRecords.DATE_TIME)}`} placement="bottom">
                            <span style={{ textDecoration: "underline", cursor: "help" }}>
                                {parseEtapaVenda((projeto?.etapa_venda as any))}
                            </span>
                        </Tooltip>
                    </>
                )
            }

        },
        {
            field: "situacao",
            headerName: "Situação",
            sortable: true,
            type: TypeRecords.TEXT,
            width: 80,
            render: (row: any) => {
                const projeto: Verticais = (row as Verticais);

                // Expirado
                if (projeto.situacao === "expirado") {
                    return (
                        <Tooltip title={`Data expiração ${Formater.toString(projeto.data_expiracao, TypeRecords.DATE_TIME)}`} placement="bottom">
                            <span style={{ textDecoration: "underline", cursor: "help", color: theme.palette.warning.main }}>
                                {parseStatusProjeto(projeto.situacao as any)}
                            </span>
                        </Tooltip>
                    )
                }

                // Cancelado
                if (projeto.situacao === "cancelado") {
                    return (
                        <Tooltip title={`Data cancelamento ${Formater.toString(projeto.data_cancelamento, TypeRecords.DATE_TIME)}`} placement="bottom">
                            <span style={{ textDecoration: "underline", cursor: "help", color: theme.palette.error.main }}>
                                {parseStatusProjeto(projeto.situacao as any)}
                            </span>
                        </Tooltip>
                    )
                }

                // Pausado
                if (projeto.situacao === "pausado") {
                    return (
                        <Tooltip title={`Data solicitação de pausa ${Formater.toString(projeto.data_solicitacao_pausa, TypeRecords.DATE_TIME)}`} placement="bottom">
                            <span style={{ textDecoration: "underline", cursor: "help", color: theme.palette.warning.main }}>
                                {parseStatusProjeto(projeto.situacao as any)}
                            </span>
                        </Tooltip>
                    )
                }

                // Revisão
                if (row.revisao_total && row.etapa_venda === "sla_engenharia") {
                    return (
                        <Tooltip title={`Projeto possui ${row.revisao_total} revis${row.revisao_total > 1 ? "ões" : "ão"}`} placement="bottom">
                            <span style={{ textDecoration: "underline", cursor: "help", color: theme.palette.info.main }}>
                                {`Revisão (${row.revisao_total})`}
                            </span>
                        </Tooltip>
                    )
                }

                let color = "inherit"
                if (projeto.situacao === "finalizado") {
                    color = theme.palette.success.main;
                }

                return (
                    <span style={{ color: color }}>
                        {parseStatusProjeto(projeto.situacao as any)}
                    </span>
                )
            }
        },
        {
            field: "ev_id",
            headerName: "Profissional de Vendas",
            sortable: true,
            type: TypeRecords.TEXT,
            width: 80,
            render: (row: any) => {
                const projeto: Verticais = (row as Verticais);
                return <>{projeto?.ev ? String(projeto?.ev?.nome) : ""}</>
            }

        },
        {
            field: "distribuidor_id",
            headerName: "Distribuidor/Revenda",
            sortable: true,
            type: TypeRecords.TEXT,
            width: 80,
            render: (row: any) => {
                const projeto: Verticais = (row as Verticais);
                return <>{projeto?.distribuidor?.nome ? String(projeto?.distribuidor?.nome) : ""}</>
            }

        },
        {
            field: "",
            headerName: "Endereço",
            type: TypeRecords.TEXT,
            render: (row: any) => {
                const projeto: any = row;
                return <><Tooltip title={`${projeto?.endereco_proposta ? projeto.endereco_proposta + ", " : ""}${projeto?.cidade?.nome}/${String(projeto?.cidade?.estado_id).toUpperCase()}`}><span>{`${projeto?.cidade?.nome}/${String(projeto?.cidade?.estado_id).toUpperCase()}`}</span></Tooltip></>
            }
        },
        {
            field: "created_updated_at",
            headerName: "Data atualização",
            type: TypeRecords.DATE_TIME,
            sortable: true,
            width: 200,
            render: (row: any, style?: CSSProperties): React.ReactNode => {
                if (row.updated_at) {
                    return (
                        <span>
                            {Formater.toString(row.updated_at, TypeRecords.DATE_TIME)}
                        </span>
                    )
                }

                return (
                    <span style={{ color: red[500] }}>
                        {Formater.toString(row.created_at, TypeRecords.DATE_TIME)}
                    </span>
                )
            }
        },
        {
            field: "data_expiracao",
            headerName: "Data expiração",
            type: TypeRecords.DATE_TIME,
            sortable: true,
            width: 200
        }
    ];

    // Inits
    dataGridStore.setIncludes(["cidade", "revenda", "distribuidor", "analista", "ev", "supervisor", "assistente"]);
    dataGridStore.setFilter(filterState);
    dataGridStore.setOrderBy(["created_updated_at-desc"]);
    dataGridStore.setEnableExport(false);
    dataGridStore.setColumnDefinitions(defaultColumn);

    const dataGridProperties: DataGridProperties = {
        columnDefinitions: defaultColumn,
        title: "Verticais",
        height: "60vh",
        width: "100%",
        provider: api,
        path: {
            list: "projetos",
            create: "projetos",
            read: "projetos",
            update: "projetos",
            delete: "projetos",
        },
        enableSearch: true,
        searchFields: ["codigo_venda"],
        store: dataGridStore,
    };

    const getRevisao = async (row: any) => {
        const _row = await dataGridStore.find(
            row.id,
            ["disposicoes", "revisoes", "solicitacao", "distribuidor", "anexos", 'revenda']
        );
        onEdit({ ...DEFAULT_PROJETO, ..._row });
    }

    useEffect(() => {
        dataGridStore.list();
        init();
    }, []);

    useEffect(() => {
        dataGridStore.setRows(dataGridStore.rows);
    }, [dataGridStore.rows]);
  
    return <>
        <DataGrid
            {...dataGridProperties}
            filters={
                <>
                    <div className="X12 M2">
                        <InputSelectSimple
                            allowNull
                            list={LISTA_SITUACAO_PROJETOS_VERTICAIS}
                            label="Situação Venda"
                            defaultValue={SITUACAO.PENDENTES}
                            value={filterState[SITUACAO_FIELD.index]?.value}
                            onChange={(value) => {
                                filterState[SITUACAO_FIELD.index].value = value;
                                setFilterState([...filterState]);
                                dataGridStore.setFilter(filterState);
                            }}
                        />
                    </div>
                    {(!distribuidorRevendaUsuario?.isDistribuidor && !distribuidorRevendaUsuario?.isRevenda) || distribuidorRevendaUsuario?.isIntelbras ? (
                        <div className="X12 M3">
                            {renderDistribuidor()}
                        </div>
                    ) : ""}

                    {distribuidorRevendaUsuario?.isIntelbras || distribuidorRevendaUsuario?.isDistribuidor ? (
                        <div className="X12 M3">
                            {renderRevenda()}
                        </div>
                    ) : ""}

                    <div className="X12 M4">
                        <InputComboBoxList
                            multiple
                            id={`list-etapas-vendas`}
                            key={`list-etapas-vendas`}
                            label={"Etapa de Venda"}
                            textField="text"
                            valueField="value"
                            options={LISTA_ETAPA_VENDA_PROJETOS_VERTICAIS}
                            autoComplete
                            value={String(filterState[ETAPA_VENDA_FIELD.index]?.value).split(",")
                                .map((id) => LISTA_ETAPA_VENDA_PROJETOS_VERTICAIS.find((etapa: any) => etapa.value === id))
                                .filter(Boolean)
                            }
                            onChange={(value: any[]) => {
                                const result = [];

                                for (const etapa of value) {
                                    result.push(etapa.value);
                                }

                                const filter = [...filterState];
                                const idx = filter.findIndex((f) => f.field === ETAPA_VENDA_FIELD.name);

                                if (idx > -1) {
                                    filter[idx].value = result.join(",");
                                    setFilterState([...filter]);
                                }
                            }}
                            renderOptions={(option: any) => {
                                return `${option.text}`
                            }}
                            renderOptionsLabel={(option: any) => {
                                return `${option.text}`
                            }}
                        />
                    </div>
                    <div className="X12 M2">
                        <InputSelectSimple
                            allowNull
                            list={LISTA_PRIORIDADE_PROJETOS_VERTICAIS}
                            label="Prioridade"
                            value={filterState[PRIORIDADE_FIELD.index].value}
                            onChange={(value) => {
                                filterState[PRIORIDADE_FIELD.index].value = value;
                                setFilterState([...filterState]);
                                dataGridStore.setFilter(filterState);
                            }}
                        />
                    </div>

                    <div className="X12 M3">
                        <InputDateTime
                            label={`Data de etapa de venda (Inicial)`}
                            fullWidth={true}
                            value={dataGridStore.getFilterState(DATA_ETAPA_INICIO_FIELD.name, null) || null}
                            onChange={(date: string | null) => {
                                const filter = [...filterState];
                                const idx = filter.findIndex((f) => f.field === DATA_ETAPA_INICIO_FIELD.name);

                                if (idx > -1) {
                                    filter[idx].value = date;
                                    setFilterState([...filter]);
                                }
                            }}
                        />
                    </div>

                    <div className="X12 M3">
                        <InputDateTime
                            label={`Data de etapa de venda (Final)`}
                            fullWidth={true}
                            value={dataGridStore.getFilterState(DATA_ETAPA_FINAL_FIELD.name, null) || null}
                            onChange={(date: string | null) => {
                                const filter = [...filterState];
                                const idx = filter.findIndex((f) => f.field === DATA_ETAPA_FINAL_FIELD.name);

                                if (idx > -1) {
                                    filter[idx].value = date;
                                    setFilterState([...filter]);
                                }
                            }}
                        />
                    </div>
                </>
            }

            advancedFilters={
                <>
                    <div className="row">
                        <div className="X12 M3">
                            <InputComboBoxList
                                multiple
                                id={`listagem-verticais-estado-cb`}
                                key={`listagem-verticais-estado-cb`}
                                label={"Estado"}
                                textField="nome"
                                valueField="id"
                                options={estadoListState?.data || []}
                                value={filterState[ESTADOS_FIELD.index]?.value
                                    ?.map((id: string) => estadoListState?.data.find((estado: Estado) => estado.id === id))
                                    .filter(Boolean) || []
                                }
                                autoComplete

                                renderOptions={(option: any) => {
                                    return `${option.id} - ${option.nome}`
                                }}
                                renderOptionsLabel={(option: any) => {
                                    return `${option.id} - ${option.nome}`
                                }}
                                onChange={(value: any) => {

                                    if (value && value.length > 0) {

                                        const estados = value.map((estado: Estado) => {
                                            return estado.id;
                                        });

                                        const filter = [...filterState];
                                        const idx = filter.findIndex((f) => f.field === ESTADOS_FIELD.name);

                                        if (idx > -1) {
                                            filter[idx].value = estados;
                                            setFilterState([...filter]);

                                            const estadosSet = new Set(String(estados).split(","));

                                            const cidades =
                                            filterState[CIDADES_FIELD.index]?.value?.map((id: number) => {
                                                    const cidade = cidadeListState?.data?.find(
                                                        (c: Cidade) => c.id === id
                                                    );

                                                    if (!cidade) return undefined;

                                                    return estadosSet.has(String(cidade.estado_id))
                                                        ? cidade.id
                                                        : undefined;
                                                }).filter((id: number): id is number => id !== undefined) || [];

                                            filterState[CIDADES_FIELD.index].value = cidades;
                                        }
                                    } else {
                                        filterState[ESTADOS_FIELD.index].value = null;
                                        filterState[CIDADES_FIELD.index].value = null;
                                    }
                                }}
                            />
                        </div>

                        <div className="X12 M3">
                            <InputComboBoxList
                                multiple
                                id={`listagem-verticais-cidade-cb`}
                                key={`listagem-verticais-cidade-cb`}
                                disabled={filterState[ESTADOS_FIELD.index]?.value ? filterState[ESTADOS_FIELD.index]?.value?.length <= 0 : true}
                                label={"Cidade"}
                                textField="nome"
                                valueField="id"
                                options={cidadeListState?.data?.filter((c: Cidade) => c.estado_id ? filterState[ESTADOS_FIELD.index]?.value?.includes(c.estado_id) : false) || []}
                                value={filterState[CIDADES_FIELD.index]?.value
                                    ?.map((id: number) => cidadeListState?.data.find((cidade: Cidade) => cidade.id === id))
                                    .filter(Boolean) || []
                                }

                                autoComplete
                                renderOptions={(option: any) => {
                                    return `${option.nome} - ${option.estado_id}`
                                }}
                                renderOptionsLabel={(option: any) => {
                                    return `${option.nome}`
                                }}
                                onChange={(value: any) => {
                                    if (value) {

                                        const cidades = value.map((cidade: Cidade) => {
                                            return cidade.id;
                                        });

                                        const filter = [...filterState];
                                        const idx = filter.findIndex((f) => f.field === CIDADES_FIELD.name);

                                        if (idx > -1) {
                                            filter[idx].value = cidades.length > 0 ? cidades : null;
                                            setFilterState([...filter]);
                                        }
                                    } else {
                                        const filter = [...filterState];
                                        const idx = filter.findIndex((f) => f.field === CIDADES_FIELD.name);

                                        if (idx > -1) {
                                            filter[idx].value = null;
                                            setFilterState([...filter]);
                                        }
                                    }

                                }}
                            />
                        </div>

                        <div className="X12 M3">
                            <InputDecimal
                                label="Range Potencia (Inicial)"
                                decimal={3}
                                sufix={"kWp"}
                                maxLength={13}
                                margin={"normal"}
                                value={filterState[RANGE_PONTENCIA_INICIO_FIELD.index]?.value}
                                onChange={(event: any) => {
                                    const filter = [...filterState];
                                    const idx = filter.findIndex((f) => f.field === RANGE_PONTENCIA_INICIO_FIELD.name);

                                    if (idx > -1) {
                                        filter[idx].value = event.target.value;
                                        setFilterState([...filter]);
                                    }
                                }}
                            />
                        </div>

                        <div className="X12 M3">
                            <InputDecimal
                                label="Range Potencia (Final)"
                                decimal={3}
                                sufix={"kWp"}
                                maxLength={13}
                                margin={"normal"}
                                value={filterState[RANGE_PONTENCIA_FINAL_FIELD.index]?.value}
                                onChange={(event: any) => {
                                    const filter = [...filterState];
                                    const idx = filter.findIndex((f) => f.field === RANGE_PONTENCIA_FINAL_FIELD.name);

                                    if (idx > -1) {
                                        filter[idx].value = event.target.value;
                                        setFilterState([...filter]);
                                    }
                                }}
                            />
                        </div>
                    </div>
                </>
            }
        />
        <ProjetosPrioridadeModel
            data={dataPrioridade}
            open={openPrioridade}
            setOpen={setOpenPrioridade}
            applyConfirmation={(data) => doPrioridade(data)}
        />
        { dataModalProposta && (
            <ModalPropostas
                codigo_venda={dataModalProposta.codigo_venda}
                projetoId={dataModalProposta.projetoId}
                open={openModalProposta}
                setOpen={setOpenModalProposta}
                mostrarValores={dataModalProposta.valoresUnitarios}
                url={dataModalProposta.url}
                tipo={dataModalProposta.tipo}
            />
        )}

    </>
}

export { Listagem }